import { cn } from "@/lib/utils";

type StatsItem = {
	label: string;
	value: number | string;
	valueClassName?: string;
};

type StatsOverviewProps = {
	title?: string;
	items: StatsItem[];
	className?: string;
};

export default function StatsOverview({
	title,
	items,
	className,
}: StatsOverviewProps) {
	return (
		<div
			className={cn(
				"bg-white p-3 rounded-lg border border-gray-200",
				className,
			)}
		>
			{title && (
				<h2 className="text-sm font-medium text-gray-700 mb-3 pb-2 border-b border-gray-100 tracking-wide">
					{title}
				</h2>
			)}
			<div className="grid grid-cols-3 gap-4">
				{items.map((item) => (
					<div key={item.label} className="text-center">
						<div
							className={cn(
								"text-xl font-medium mb-1 text-gray-700",
								item.valueClassName,
							)}
						>
							{item.value}
						</div>
						<div className="text-[11px] text-gray-500">{item.label}</div>
					</div>
				))}
			</div>
		</div>
	);
}
